import { Rocket, Star } from 'lucide-react';
import './AccountsUI.css';

export function SpaceIllustration({ compact = false }) {
  return <div className={`tmag-space-art${compact ? ' tmag-space-art--compact' : ''}`} aria-hidden="true">
    <span className="tmag-space-art__orbit" /><span className="tmag-space-art__planet" />
    <Rocket className="tmag-space-art__rocket" strokeWidth={1.5} />
    <Star className="tmag-space-art__star" fill="currentColor" />
  </div>;
}

export function MissionSteps({ steps, current }) {
  return <ol className="tmag-mission-steps" aria-label="Pasos">
    {steps.map((step, index) => <li key={step} aria-current={index === current ? 'step' : undefined}>
      <span aria-hidden="true">{index + 1}</span>{step}
    </li>)}
  </ol>;
}
